import React, { useEffect, useState } from "react";
import "../../components/DashboardModule/Analytics.css";
import { getSellerEnquiryAnalytics } from "../../API/Api";
import PendingQuotes from "./PendingQuotes";
import QuotationShared from "./QuotationShared";
import CompletedOrderSeller from "./CompletedOrderSeller";


const AnalyticsSeller = () => {
	const [analyticsData, setAnalyticsData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [activeComponent, setActiveComponent] = useState(null);

	useEffect(() => {
		const fetchAnalyticsData = async () => {
			try {
				const response = await getSellerEnquiryAnalytics();
				setAnalyticsData(response.data);
				setLoading(false);
			} catch (err) {
				setError(err.message || "Failed to fetch analytics data");
				setLoading(false);
			}
		};

		fetchAnalyticsData();
	}, []);

	switch (activeComponent) {
		case 'pending':
			return <PendingQuotes onBack={() => setActiveComponent(null)} />;
		case 'quotation':
			return <QuotationShared onBack={() => setActiveComponent(null)} />;
		case 'completed':
			return <CompletedOrderSeller onBack={() => setActiveComponent(null)} />;
		default:
			break;
	}

	if (loading) return <div className="analytics-container">Loading...</div>;
	if (error) return <div className="analytics-container">Error: {error}</div>;
	if (!analyticsData) return null;

	const summaryData = [
		{
			title: "Total Enquiries",
			value: analyticsData.total,
			className: "completed",
			clickable: true,
			onClick: () => setActiveComponent('pending')
		},
		{
			title: "Pending Enquiries",
			value: analyticsData.pending,
			className: "pending",
			clickable: true,
			onClick: () => setActiveComponent('pending')
		},
		{
			title: "My Quotation",
			value: analyticsData.processed,
			className: "completed",
			clickable: true,
			onClick: () => setActiveComponent('quotation')
		},
		{
			title: "Successful Enquiries",
			value: analyticsData.success,
			className: "completed",
			clickable: true,
			onClick: () => setActiveComponent('completed')
		},
	];

	const detailedData = [
		{
			title: "My Quotation",
			value: analyticsData.processed,
			className: "pending",
			clickable: true,
			onClick: () => setActiveComponent('quotation')
		},
		{
			title: "Total Enquiries",
			value: analyticsData.total,
			className: "completed",
			clickable: true,
			onClick: () => setActiveComponent('pending')
		},
		{
			title: "Pending Enquiries",
			value: analyticsData.pending,
			className: "pending",
			clickable: true,
			onClick: () => setActiveComponent('pending')
		},
		{
			title: "Successful Enquiries",
			value: analyticsData.success,
			className: "completed",
			clickable: true,
			onClick: () => setActiveComponent('completed')
		},
	];

	return (
		<div className="analytics-container">
			<div className="top-summary font-poppins summary-box">
				{summaryData.map((item, index) => (
					<div
						key={index}
						className={`${item.className}-analy ${item.clickable ? 'clickable' : ''}`}
						onClick={item.onClick}
					>
						<span className="title">
							{(item.className === "completed" && (
								<span className="status-circle completed-circle"></span>
							)) ||
								(item.className === "pending" && (
									<span className="status-circle pending-circle"></span>
								))}
							{item.title}
						</span>
						<span className="value">{item.value}</span>
					</div>
				))}
			</div>

			<div className="detailed-boxes">
				{detailedData.map((item, index) => (
					<div
						key={index}
						className={`detail-box ${item.className}-analy ${item.clickable ? 'clickable' : ''}`}
						onClick={item.onClick}
					>
						<span className="title">
							{(item.className === "completed" && (
								<span className="status-circle completed-circle"></span>
							)) ||
								(item.className === "pending" && (
									<span className="status-circle pending-circle"></span>
								))}
							{item.title}
						</span>
						<span className="value">{item.value}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default AnalyticsSeller;